import React, { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import CardContainer from "../Cards/Cardcontainer2";
import calendar from "../../assets/calender.svg"
import engine1 from "../../assets/engine1.gif"
import distance1 from "../../assets/distance1.gif"
import time1 from "../../assets/time1.svg"
import fuel1 from "../../assets/fuel1.gif"
import fuellost1 from "../../assets/fuellost1.gif"
import timefleet from "../../assets/images/timefleet.svg"
import fuelefficency1 from "../../assets/Fuelefficency1.svg"
import distanceic from "../../assets/images/distanceic.png"
import Groupcal from "../../assets/images/Groupcal.svg"
import gasfleet from "../../assets/images/gasfleet.png"
import fuelicon from "../../assets/images/fuellicon.png"
import piston from "../../assets/images/piston.png"

import {
  getAvgDistCoveredPerDayPerVin,
  getAvgFuelConsumedInKmplLitHour,
  getDistCoveredPerMonthPerVin,
  getEngineHoursOnPerMonthVin,
  getEngineRuntimeHrsDays,
  getEngineRuntimeHrsMonth,
  getFuelConsumedInKmplLtrHour,
  getMedianFuelConsumedKmpl,
  getTotalDistDays,
  getTotalDistMonth,
  getTotalDistTravel,
  getTotalFuelLostLit,
  getTotalHrEngineOn,
  getVehicleCount,
} from "./FleetData_";
import Vehiclefuelcard from "../Cards/Vehiclefuelcard";
import { Calendar } from "@rsuite/icons";
import { FilterContext } from "../../context/Filter";

const EngIndicator = () => {
  // const { arn: parArn, childArn } = useContext(FilterContext);
  const { superArn: parArn, childArn, open } = useContext(FilterContext);


  const isValid = (val) => val && val !== '""' && val !== "";

  let arnKey = null;
  let arnValue = null;

  if (isValid(parArn)) {
    arnKey = "parArn";
    arnValue = parArn;
  }

  if (isValid(childArn)) {
    arnKey = "childArn";
    arnValue = childArn;
  }

  const enabled = !!arnKey && !!arnValue;

  const [dateRange, setDateRange] = useState({
    startDate: "",
    endDate: "",
    dayCount: 0,
    monthDiff: 0,
  });

  useEffect(() => {
    const endDate = new Date();
    const startDate = new Date();
    startDate.setMonth(startDate.getMonth() - 3);
    startDate.setDate(1);

    const startYear = startDate.getFullYear();
    const startMonth = startDate.getMonth() + 1;
    const endYear = endDate.getFullYear();
    const endMonth = endDate.getMonth() + 1;

    const dayCount = Math.floor((endDate - startDate) / (1000 * 3600 * 24)) + 1;
    const monthDiff = endMonth - startMonth + 12 * (endYear - startYear) + 1;

    setDateRange({
      startDate: startDate.toISOString().split("T")[0],
      endDate: endDate.toISOString().split("T")[0],
      dayCount,
      monthDiff,
    });
  }, []);

  const { data: vehicleCountData } = useQuery({
    queryKey: ["vehicleCount", arnValue],
    queryFn: () => getVehicleCount(arnKey, arnValue),
    enabled,
  });
  // console.log("vehiclecount", vehicleCountData?.vehicle_count?.value)

  const { data: TotalDistTravelData } = useQuery({
    queryKey: ["totalDistance", arnValue],
    queryFn: () => getTotalDistTravel(arnKey, arnValue),
    enabled,
  });

  // console.log("total dis", TotalDistTravelData?.value)




  const { data: distCoveredPerMonthPerVinData } = useQuery({
    queryKey: ["distanceCoveredPerMonth", arnValue],
    queryFn: () => getDistCoveredPerMonthPerVin(arnKey, arnValue),
    enabled,
  });

  // console.log("dispermonth", distCoveredPerMonthPerVinData)

  const { data: getTotalHrEngineOnData } = useQuery({
    queryKey: ["TotalHrEngineOn", arnValue],
    queryFn: () => getTotalHrEngineOn(arnKey, arnValue),
    enabled,
  });

  // console.log("getTotalHrEngineOnData", getTotalHrEngineOnData?.Engine_Runtime_Hrs?.value)

  const totalEngineRunPerDay = (
    getTotalHrEngineOnData?.Engine_Runtime_Hrs?.value / dateRange.dayCount
  )?.toFixed(2);
  const avgEngineSpeedPerHr = (
    TotalDistTravelData?.value /
    getTotalHrEngineOnData?.Engine_Runtime_Hrs?.value
  )?.toFixed(2);

  // console.log("totalEngineRunPerDay", totalEngineRunPerDay)

  const { data: getEngineHoursOnPerMonthVinData } = useQuery({
    queryKey: ["EngineHoursOnPerMonthVin", arnValue],
    queryFn: () => getEngineHoursOnPerMonthVin(arnKey, arnValue),
    enabled,
  });

  // console.log("getEngineHoursOnPerMonthVinData", getEngineHoursOnPerMonthVinData)

  const { data: getAvgFuelConsumedInKmplLitHourData } = useQuery({
    queryKey: ["AvgFuelConsumedInKmplLitHour", arnValue],
    queryFn: () => getAvgFuelConsumedInKmplLitHour(arnKey, arnValue),
    enabled,
  });
  // console.log("avgfuelconsumed", getAvgFuelConsumedInKmplLitHourData?.val)
  // console.log("avgfuelconsumedfe", getAvgFuelConsumedInKmplLitHourData?.feKmPl)



  const { data: getFuelConsumedInKmplLtrHourData } = useQuery({
    queryKey: ["FuelConsumedInKmplLtrHour", arnValue],
    queryFn: () => getFuelConsumedInKmplLtrHour(arnKey, arnValue),
    enabled,
  });

  // console.log("getFuelConsumedInKmplLtrHourData", getFuelConsumedInKmplLtrHourData?.values?.["50.0"])

  const feKmPlHr = (
    getAvgFuelConsumedInKmplLitHourData?.val /
    getTotalHrEngineOnData?.Engine_Runtime_Hrs?.value
  )?.toFixed(2);


  // console.log("feKmPlHr", feKmPlHr)

  const { data: getMedianFuelConsumedKmplData } = useQuery({
    queryKey: ["MedianFuelConsumedKmpl", arnValue],
    queryFn: () => getMedianFuelConsumedKmpl(arnKey, arnValue),
    enabled,
  });

  // console.log("getMedianFuelConsumedKmplData", getMedianFuelConsumedKmplData?.values?.["50.0"])

  const { data: getTotalFuelLostLitData } = useQuery({
    queryKey: ["TotalFuelLostLit", arnValue],
    queryFn: () => getTotalFuelLostLit(arnKey, arnValue),
    enabled,
  });

  // console.log("getTotalFuelLostLitData", getTotalFuelLostLitData?.value)

  const totalFuelLostPerDay = (
    getTotalFuelLostLitData?.value / dateRange.dayCount
  )?.toFixed(2);
  const totalFuelLostPerMonth = (
    getTotalFuelLostLitData?.value / dateRange.monthDiff
  )?.toFixed(2);


  const { data: getEngineRuntimeHrsDaysData } = useQuery({
    queryKey: ["EngineRuntimeHrsDays", arnValue],
    queryFn: () => getEngineRuntimeHrsDays(arnKey, arnValue),
    enabled,
  });



  const { data: getEngineRuntimeHrsMonthData } = useQuery({
    queryKey: ["EngineRuntimeHrsMonth", arnValue],
    queryFn: () => getEngineRuntimeHrsMonth(arnKey, arnValue),
    enabled,
  });

  const { data: getTotalDistMonthData } = useQuery({
    queryKey: ["TotalDistMonth", arnValue],
    queryFn: () => getTotalDistMonth(arnKey, arnValue),
    enabled,
  });

  const { data: getTotalDistDaysData } = useQuery({
    queryKey: ["TotalDistDays", arnValue],
    queryFn: () => getTotalDistDays(arnKey, arnValue),
    enabled,
  });


  const { data: getAvgDistCoveredPerDayPerVinData } = useQuery({
    queryKey: ["AvgDistCoveredPerDayPerVinData", arnValue],
    queryFn: () => getAvgDistCoveredPerDayPerVin(arnKey, arnValue),
    enabled,
  });

  // console.log("getAvgDistCoveredPerDayPerVinData ", getAvgDistCoveredPerDayPerVinData)


  if (!enabled) {
    return (
      <div className="text-sm text-red-400 text-center">
        No Data Available For This ARN
      </div>
    );
  }

  let arr = [{
    heading: "Distance",
    Parheading: " Total Distance(KM)",
    paricon: distanceic,
    parentbadge: "(KM)",
    parvalue: parseFloat((TotalDistTravelData?.value ?? 0).toFixed(2)),
    childicon1: Groupcal,
    childicon2: timefleet,
    childtitle1: "Distance/Month",
    childtitle2: "Distance/Day(KM)",
    childval1: (distCoveredPerMonthPerVinData ?? 0).toFixed(2),
    childval2: getAvgDistCoveredPerDayPerVinData,
    childbadge1: "(KM)",
    childbadge2: "(KM)",


  }, {
    heading: "Engine",
    Parheading: " Total Runtime (Hr) ",
    paricon: piston,
    parentbadge: "(Hrs)",
    parvalue: (getTotalHrEngineOnData?.Engine_Runtime_Hrs?.value ?? 0).toFixed(2),
    childicon1: Groupcal,
    childicon2: timefleet,
    childtitle1: "Engine ON Hrs/Month",
    childtitle2: "Engine ON Hrs/Day & Avg Speed/Hr",
    childval1: (getEngineHoursOnPerMonthVinData ?? 0).toFixed(2),
    childval2: totalEngineRunPerDay,
    childbadge1: "(Hrs)",
    childbadge2: "(Hrs)",


  },
  {
    heading: "Fuel",
    Parheading: " Total Fuel Consumed (Ltr)",
    paricon: gasfleet,
    parentbadge: "(Ltr)",
    parvalue: (getAvgFuelConsumedInKmplLitHourData?.val ?? 0).toFixed(2),
    childicon1: fuelefficency1,
    childicon2: timefleet,
    childtitle1: "FE KPML & Ltr/Hr",
    childtitle2: "Median fuel comsumed (KMPL) & Ltr / Hr",
    childval1: (getAvgFuelConsumedInKmplLitHourData?.feKmPl ?? 0).toFixed(2),
    childval1a: feKmPlHr,
    childval2: (getMedianFuelConsumedKmplData?.values?.["50.0"] ?? 0).toFixed(2),
    childval2a: (getFuelConsumedInKmplLtrHourData?.values?.["50.0"] ?? 0).toFixed(2),
    childbadge1: "",
    childbadge2: "",
    childbadge1a: "(Ltr/Hr)",
    childbadge2a: ""


  }, {
    heading: "Fuel Lost",
    Parheading: " Total Fuel Lost (Ltr)",
    paricon: fuelicon,
    parentbadge: "(Ltr)",
    parvalue: getTotalFuelLostLitData?.value?.toFixed(2),
    childicon1: Groupcal,
    childicon2: timefleet,
    childtitle1: "Fuel Lost/Month",
    childtitle2: "Fuel Lost/ Day",
    childval1: getTotalFuelLostLitData?.value / dateRange.monthDiff,
    childval2: (getTotalFuelLostLitData?.value / dateRange.dayCount).toFixed(2),
    childbadge1: "(Ltr)",
    childbadge2: "(Ltr)",



  }
  ]
  // console.log("count", vehicleCountData);
  return (
    <div>
      <div className={` w-96 md:w-full md:${open ? 'w-[1000px]' : 'w-[1200px]'} m-1  rounded-t-md  text-md bg-[#056DB3] text-white font-bold`}>
        <h1 className=" text-md p-1  pl-2 ">Fleet Insights</h1>

      </div>
      {
        vehicleCountData === 0 ? (
          <div className="text-center mt-3 mb-6 text-sm  text-red-600">
            Data not available for this ARN
          </div>
        ) : (
          <>
            <div className=" mb-2 w-full block lg:flex bg-white   ">

              <Vehiclefuelcard totalvehiclecount={vehicleCountData?.vehicle_count?.value} avgfuelconsumed={getAvgFuelConsumedInKmplLitHourData?.feKmPl.toFixed(2)} feKmPlHr={feKmPlHr} />

              {/* <div className="block lg:flex relative w-full  h-full bg-white mb-2 "> */}
              <div className={`flex flex-col lg:flex-row gap-2  ${open ? 'max-w-[600px]' : 'max-w-[1000px]'} w-full`}>

                {arr.map((item) => {
                  return (
                    <CardContainer item={item} totalvehiclecount={vehicleCountData?.vehicle_count?.value} />
                  )
                })}
              </div>



            </div>
          </>
        )
      }
    </div>

  );
};

export default EngIndicator;